/**
 * Turning registry keys into words a poker player uses.
 *
 * The keys are precise and unreadable — `bubble/sng_9max_top2` — and a selector full
 * of them would make a customer guess at what they are choosing. Kept separate from
 * the component so the wording can be tested and changed without touching the screen.
 */
export interface ContextRow {
  icm_context: string | null;
  payout_preset: string | null;
}

const LADDER: Record<string, string> = {
  mtt_ft9: "9-handed final table",
  mtt_ft6: "6-handed final table",
  mtt_bubble8: "8 of 9 paid",
  mtt_bubble5: "5 of 6 paid",
  sng_9max_top2: "top 2 paid",
  sng_9max_top3: "top 3 paid",
  sng_6max_top2: "top 2 paid",
  hu_winner: "winner takes all",
};

const STAGE: Record<string, string> = {
  bubble: "Bubble",
  ladder: "In the money",
  prebubble: "Before the bubble",
};

export function contextLabel(r: ContextRow): string {
  const icm = r.icm_context;
  // No ICM context means the payout is winner-take-all, where chips are just chips.
  if (!icm || icm === "none") return "Chip EV — winner takes all";
  const ladder = LADDER[r.payout_preset ?? ""] ?? r.payout_preset ?? "";
  return `${STAGE[icm] ?? icm} — ${ladder}`;
}
